const gsapScroll = gsap => {
  const left = document.querySelectorAll('.left');
  const right = document.querySelectorAll('.right');
  const bottom = document.querySelectorAll('.bottom');
  // left
  left.forEach(item => {
    gsap.from(item, {
      x: -100,
      duration: 0.3,
      ease: 'power4.inout',
      opacity: 0,
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        once: true,
      },
    });
  });
  // right
  right.forEach(item => {
    gsap.from(item, {
      x: 100,
      duration: 0.3,
      ease: 'power4.inout',
      opacity: 0,
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        once: true,
      },
    });
  });
  // bottom
  bottom.forEach(item => {
    gsap.from(item, {
      y: 100,
      duration: 0.3,
      ease: 'power4.inout',
      opacity: 0,
      scrollTrigger: {
        trigger: item,
        start: 'top bottom',
        once: true,
      },
    });
  });
};
export default gsapScroll;
